import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-domain-add-modal',
  templateUrl: './domain-add-modal.component.html',
  styleUrls: ['./domain-add-modal.component.scss']
})
export class DomainAddModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
